
<template>
   <v-app id="app" ref="app" v-bind:class="{ 'is-waiting': isWaiting }">

      <div v-for="realm in loggedInUserRealms">
         <img :src="realm.params.style.logo" class="logo"/>
      </div>

      <div v-if="isToolbarVisible">
         <v-toolbar :color="mainColor" dark >

            <v-toolbar-title>
               <h3 @click="home()">
                  {{ title }}
               </h3>
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn flat>
               {{ platform === 'shdl' ? "Université de Toulouse - INPT - ENSEEIHT - JCB" : "Hôpitaux de Toulouse" }}
            </v-btn>
            <v-btn flat>
               v1.13.2
            </v-btn>
            <v-menu bottom left v-if="isAuthenticated">
               <v-btn flat slot="activator">
                  {{ loggedInUserDescription }}
               </v-btn>
               <v-list>
                  <v-list-tile @click="logout()">
                     <v-list-tile-title>Déconnexion</v-list-tile-title>
                  </v-list-tile>
               </v-list>
            </v-menu>

            <v-btn flat v-if="!isAuthenticated" @click="login()">
               Connexion
            </v-btn>

         </v-toolbar>

         <v-tabs v-if="isAuthenticated" icons-and-text centered dark :color="mainColor" v-model="currentTab">
            <v-tabs-slider color="yellow"></v-tabs-slider>

            <v-tab :to="{path: activity.url}" router
                   v-for="activity in authorizedActivities"
                   v-if="activity.tab"
                   :key="activity.uid">
               {{ activity.tab.name }}
               <v-badge right color="brown">
                  <span slot="badge" v-if="activity.uid === 'messages' && unreadMessageCount > 0">{{ unreadMessageCount }}</span>
                  <v-icon>{{ activity.tab.icon }}</v-icon>
               </v-badge>
            </v-tab>

         </v-tabs>
         
      </div>

      <v-content ccccccclass="global--background" v-bind:class="{ 'global--background-shrink': shrink }">
         <router-view @onLogin="onLogin" @onLogout="onLogout"></router-view>
      </v-content>

      <!--v-footer color="orange" app inset>
         <span class="white--text">&copy; 2018 </span><a href="http://buisson.perso.enseeiht.fr">JCB</a>
      </v-footer-->

      <v-dialog v-model="invitationDialog" persistent max-width="400">
         <v-form v-model="valid">
            <v-card>
               <v-card-title class="headline grey lighten-2">Envoi d'une invitation</v-card-title>
               <v-container grid-list-md>
                  <v-layout wrap>
                     <v-flex xs12>
                        <v-text-field
                           label="E-mail"
                           v-model="email"
                           :rules="emailRules"
                           required
                        ></v-text-field>
                     </v-flex>
                  </v-layout>
               </v-container>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :color="mainColor" flat :disabled="!valid" @click.native="invitationDialog = false; inviteCoach()">Envoyer</v-btn>
                  <v-btn :color="mainColor" flat @click.native="invitationDialog = false">Annuler</v-btn>
               </v-card-actions>
            </v-card>
         </v-form>
      </v-dialog>

      <v-snackbar
         :timeout="snackbarOptions.timeout"
         :top="true"
         :bottom="false"
         :right="false"
         :left="false"
         :color="snackbarOptions.color"
         :multi-line="true"
         :vertical="true"
         v-model="snackbar"
      >
         {{ snackbarOptions.text }}
      </v-snackbar>

      <confirm-dialog />

   </v-app>
</template>



<script>
   import config from '@/config'
   const axios = require("axios")

   import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'

   export default {
      components: {
         ConfirmDialog,
      },
      data () {
         return {
            currentTab: null,
            authorizedDefined: false,
            shrink: false,
            interval: null,
            invitationDialog: false,
            valid: false,
            email: '',
            emailRules: [
               (v) => !!v || "L'e-mail est obligatoire",
               (v) => /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/.test(v) || "l'email doit être valide"
            ],
         }
      },
      computed: {
         // 'nutrieduc', 'shdl'
         platform () {
            return this.$store.getters.platform
         },
         title () {
            if (this.isAuthenticated) {
               return this.$store.getters.loggedInUserRealms.map(realm => realm.params.style.title).join(' - ')
            } else {
               if (this.platform === 'shdl') {
                  return "Simple Hardware Description Language"
               } else {
                  return "Diabétologie, Nutrition et Hygiène de vie"
               }
            }
         },
         isWaiting () {
            return this.$store.state.waiting
         },
         snackbar: {
            get: function() {
               return this.$store.state.snackbar
            },
            set: function(newValue) {
               this.$store.commit('SNACKBAR_SET', newValue)
            }
         },
         snackbarOptions () {
            return this.$store.state.snackbarOptions
         },
         loggedInUser () {
            return this.$store.getters.loggedInUser
         },
         authorized () {
            return this.$store.getters.authorized
         },
         authorizedActivities () {
            return this.$store.getters.authorizedList.map(uid => this.authorized[uid])
         },
         loggedInUserRealms () {
            return this.$store.getters.loggedInUserRealms
         },
         mainColor () {
            let color = 'brown darken-1'
            if (this.loggedInUserRealms && this.loggedInUserRealms.length >= 0) {
               let firstRealm = this.loggedInUserRealms[0]
               if (firstRealm && firstRealm.params && firstRealm.params.style) {
                  color = firstRealm.params.style.mainColor
               }
            }
            return color
         },

         isAuthenticated () {
            return this.$store.state.authenticationData;
         },
         loggedInUserDescription () {
            if (this.loggedInUser) {
               if (this.loggedInUser.first_name + this.loggedInUser.last_name) {
                  return this.loggedInUser.first_name + ' ' + this.loggedInUser.last_name
               } else if (this.loggedInUser.extra.fullname) {
                   return this.loggedInUser.extra.fullname
               } else {
                  return this.loggedInUser.username
               }
            } else {
               return ''
            }
         },
         isToolbarVisible () {
            if (this.$route.path === "/activate-user") return false
            if (this.$route.path === "/login") return false
            if (this.$route.path === "/accept-invitation") return false
            if (this.$route.path === "/fitbit-authorized") return false
            if (this.$route.path === "/salutance-news") return false
            if (this.$route.path === "/nutrikiosk") return false
            return true
         },
         unreadMessageCount () {
            return this.$store.state.user2unreadMessageCount[this.loggedInUser.id]
         },
      },

      methods: {
         home: function() {
            this.$router.push('/')
         },
         isMemberOf (groupUid) {
            try {
               return this.loggedInUser.group_uids.indexOf(groupUid) !== -1
            } catch(err) {
               return false
            }
         },
         login () {
            this.$router.push('/login')
         },
         logout () {
            // go to logout screen
            this.$router.push('/logout')
         },

         // called after Login component has found the route to go to
         onLogin (url) {
            //console.log('onLogin')
            this.$router.push(url)

            // count unread message to update badge reactively
            this.$store.dispatch('COUNT_UNREAD_MESSAGES', this.loggedInUser.id)

            /*
            // setup a timer to check authentication status regularly after having been logged
            let self = this
            this.interval = setInterval(function () {
               self.$store.commit('UPDATE_AUTHENTICATION_STATUS')
               if (!self.isAuthenticated) {
                  self.onLogout()
               }
            }, 180000)
            */
         },

         onLogout () {
            //console.log('onLogout')
            clearInterval(this.interval)
            this.interval = null // necessary - why ?
         },

         clearInvitationForm () {
            this.email = ''
         },

         async inviteCoach () {
            let authData = this.$store.state.authenticationData
            this.$store.commit('WAITING', true)
            try {
               await axios({
                  method: 'post',
                  url: config.INVITE_CAREGIVER_URL,
                  headers: {"Authorization": `JWT ${authData.token}`},
                  data: { user_id: this.loggedInUser.id, coach_email: this.email },
               })
               this.$emit('snackbar', {
                  timeout: 3500,
                  text: `Un mail d'invitation vient d'être envoyé à ${this.email}`,
                  color: 'green'
               })
            } catch(e) {
               this.$emit('snackbar', {
                  timeout: 3500,
                  text: `Une erreur s'est produite lors de l'envoi du mail d'invitation`,
                  color: 'red'
               })
            } finally {
               this.$store.commit('WAITING', false)
            }
         },
      },

      mounted: async function() {
         // print node env (see client/src/config/index.js)
         console.log('process.env.NODE_ENV =', process.env.NODE_ENV)
         // start shrinking background image
         this.shrink = true
         // store app height in state
         this.$store.commit('SET_APP_HEIGHT', this.$refs.app.clientHeight)
         // get HTTP_REFERER: unlocks computed properties 'platform' & 'title'
         await this.$store.dispatch('GET_HTTP_REFERER')
         console.log('httpReferer', this.$store.state.httpReferer)
         // reset state
         this.$store.commit('RESET_STATE')
      },
   }
</script>


<style lang="scss" type="text/scss">

    /*.fullscreen {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }*/

   .CodeMirror {
      height: auto; // important - automatic height of editor window
   }

   $color-navbar: brown;

   .x {
      color: green;
   }

   Page {
      font-size: 15;
   }
   TextField {
      padding: 10;
      font-size: 13;
   }

   .clear {
      clear: both;
   }

   .err-msg {
      color: red;
   }


   .Aligner {
      display: flex;
      align-items: center;
      justify-content: center;
   }

   .Aligner-item {
      max-width: 50%;
   }

   .Aligner-item--top {
      align-self: flex-start;
   }

   .Aligner-item--bottom {
      align-self: flex-end;
   }


   .logo {
      position: absolute;
      top: 10px;
      left: 10px;
      height: 90px;
      z-index: 1000;
   }

   /* for markdown doc */
   pre {
      background: #f2f2f2;
      margin: 10px;
      padding: 10px;
   }
   code {
      color: #1a1a1a;
      font-size: 0.9em;
      font-weight: normal;
      background: #f2f2f2;
      box-shadow: none;
   }
   code::before, code::after {
      content: none;
      box-sizing: none;
   }
   
   .craps_doc_markdown {
      h1 {
         margin: 0.2em 0 0.5em;
      }
      h2 {
         margin: 1.07em 0 0.535em;
      }
      h3 {
         color: red;
      }
      h1, h2 {
         border-bottom: 1px solid #aaa;
      }
   }


/*
   .global--appearing {
      animation-name: global--appearing;
      animation-duration: 0.5;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
   }
   @keyframes global--appearing {
      from { opacity: 0; }
      to { opacity: 1.0; }
   }
   
   .global--disappearing {
      animation-name: global--disappearing;
      animation-duration: 0.5;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
   }
   @keyframes global--disappearing {
      from { opacity: 1.0; }
      to { opacity: 0; }
   }


   .global--background {
      background-image: url("./assets/img/bg_login@3x.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
   }
   @keyframes global--background-shrink {
      0% { background-size: 120% auto; }
      100% { background-size: 100% auto; }
   }
   .global--background-shrink {
      animation-name: global--background-shrink;
      animation-duration: 20s;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
      animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
   }
*/
   .is-waiting {
      position: relative;
      transition-duration: .3s;
      > * {
         opacity: .8;
      }
      &:before {
         content: '';
         height: 100%;
         left: 0;
         position: absolute;
         top: 0;
         width: 100%;
         z-index: 9;
      }
      &:after {
         background: {
            image: url(data:image/svg+xml;base64,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);
            position: center;
            size: cover;
         }
         content: '';
         height: 64px;
         left: 50%;
         position: absolute;
         top: 50%;
         transform: translate(-50%, -50%);
         width: 64px;
      }
   }

</style>



// WEBPACK FOOTER //
// App.vue?1a2b7030